import { SCENE_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: SCENE_MNG,
  params: null,
  customParams: {},
  relationSearch: true,
  allowStatus: {
    SceneFeatureRelate: {
      expression: function(row) {
        return row.sceneType !== 'LIMIT_SCENE'
      }
    },
    ProductUpgrade: {
      expression: function(row) {
        return row.sceneType !== 'LIMIT_SCENE'
      }
    }
  },
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入场景名',
    moreBtnWidth: 160,
    searchFieldNameArr: ['sceneName'],
    hasColAdjustment: true,
    pageSizes: [50, 100],
    items: [
      {
        slot: 'left',
        label: 'sk.back',
        action: 'ReturnPage'
      },
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'success',
          icon: 'el-icon-plus'
        },
        action: 'SceneCreate'
      },
      {
        slot: 'refresh-rigtht',
        label: '批量设置场景目录',
        props: {
          type: 'primary',
          icon: 'el-icon-edit'
        },
        action: 'BatchUpdateSceneDir'
      },
      {
        slot: 'refresh-rigtht',
        label: '批量升级产品版本',
        props: {
          type: 'primary',
          icon: 'el-icon-edit'
        },
        action: 'BatchUpdateProduct'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          type: 'selection', // 包括 selection、radio、index等类型
          width: 55
        }
      },
      {
        props: {
          label: '场景名',
          prop: 'sceneName',
          sortField: 'sceneName',
          width: 320
        }
      },
      {
        props: {
          label: '场景目录',
          prop: 'sceneDirName',
          sortField: 'sceneDirName',
          width: 220
        }
      },
      {
        props: {
          label: '推荐产品版本',
          prop: 'productName',
          sortField: 'productName',
          width: 200
        }
      },
      {
        props: {
          label: '场景类型',
          prop: 'sceneType',
          sortField: 'sceneType',
          width: 120
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'sceneType'
      },
      {
        props: {
          label: '场景特征',
          prop: 'sceneDesc',
          width: 350
        }
      },
      {
        props: {
          label: '注意事项',
          prop: 'instructions'
        }
      },
      {
        props: {
          label: '应对措施',
          prop: 'solutionCase'
        }
      },
      {
        props: {
          label: '场景编码',
          prop: 'sceneCode',
          sortField: 'sceneCode'
        }
      },
      {
        props: {
          label: '终端模式',
          prop: 'desktopArch'
        }
      },
      {
        props: {
          label: '桌面模式',
          prop: 'desktopType'
        }
      },
      {
        props: {
          label: '推荐服务器型号',
          prop: 'recommendServer'
        }
      },
      {
        props: {
          label: '推荐终端型号',
          prop: 'recommendTerminalName'
        }
      },
      {
        props: {
          label: '客户问题',
          prop: 'customerProblem',
          width: 350
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '业务版本号',
          prop: 'busiVersion',
          sortField: 'busiVersion'
        }
      },
      {
        //操作
        props: {
          showBtnNum: '3'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '关联功能',
        command: 'SceneFeatureRelate',
        name: 'SceneFeatureRelate',
        tip: '禁止场景不支持关联功能'
      },
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'SceneEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-menu',
        label: '升级产品版本',
        command: 'ProductUpgrade',
        name: 'ProductUpgrade',
        tip: '禁止场景不支持升级产品版本'
      },
      {
        icon: 'el-icon-edit',
        label: '关联细分场景',
        command: 'segmentSceneRelate',
        name: 'segmentSceneRelate',
        tip: '关联细分场景'
      },

      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'SceneDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.sceneMng.deleteMsg'
        }
      }
    ]
  }
}
